<div
    class="create-transaction-input"
    [formGroup]="transactionForm"
>
    <ng-template #stage>
        <div *appVar="transactionForm.get('stage') as control">
            <label>Transaction Stage</label>
            <br />
            <p-dropdown
                class="full-width"
                placeholder="Select a Stage"
                appendTo="body"
                [options]="transactionStages"
                formControlName="stage"
            >
                <ng-template
                    let-stage
                    pTemplate="item"
                >
                    <span>{{stage | titlecase}}</span>
                </ng-template>
                <ng-template
                    let-value
                    pTemplate="selectedItem"
                >
                    <span>{{value | titlecase}}</span>
                </ng-template>
            </p-dropdown>
            <app-validation-messages [control]="control">
            </app-validation-messages>
        </div>
    </ng-template>

    <ng-template #remarks>
        <div *appVar="transactionForm.get('remarks') as control">
            <br>
            <div
                #remarksWrapper
                style="width: 100%"
            >
                <quill-editor
                    formControlName="remarks"
                    format="object"
                    [modules]="remarksQuillModules"
                    [style]="{ height: '150px', minHeight: '150px' }"
                    placeholder="Enter any additional remarks (optional)"
                    (onEditorCreated)="setRemarksValidator($event); setupEditorEventPrevention($event);"
                    (onContentChanged)="setRemainingCharCount($event)"
                    [bounds]="quillEditorWrapper().nativeElement"
                    [trackByFn]="true"
                    [sanitize]="false"
                ></quill-editor>
            </div>
            <div class="character-counter-wrapper d-flex justify-content-between align-items-center mt-1">
                <small
                    class="form-text"
                    [class.field-error-message]="control.invalid"
                >
                    {{ remainingCharCount }} / {{ maxRemarksLength }} characters
                </small>
            </div>
        </div>
    </ng-template>
</div>

<ng-template #remarksReview>
    <quill-editor
        class="remarks-content"
        [readOnly]="true"
        [ngModel]="transactionForm.value.remarks"
        [modules]="{ toolbar: false }"
        format="object"
        placeholder="No remarks"
    ></quill-editor>
</ng-template>

<app-mutate-object
    #mutate
    [fg]="transactionForm"
    objectType="Transaction"
    [mutateType]="mutateType"
    [steps]="steps"
    (objectMutated)="mutateObject()"
></app-mutate-object>